// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"47fb1a94","703":"aebb34cd"}[chunkId] + ".chunk.js";
};